"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBPaginator", {
  enumerable: true,
  get: function get() {
    return _SVBPaginator.default;
  }
});
var _SVBPaginator = _interopRequireDefault(require("./src/SVBPaginator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }